import {
  LOB_OPTIONS_ALL,
  DEPT_OPTIONS_BASE,
  AA_DEPT_MAP,
} from "../CreateNew/CreateNewForm/Clients/ClientFields";

export { LOB_OPTIONS_ALL, DEPT_OPTIONS_BASE, AA_DEPT_MAP };

export const getSpocLobOptions = () => LOB_OPTIONS_ALL;

export const getSpocDeptOptions = (lobType) => {
  if (!lobType) return DEPT_OPTIONS_BASE;

  const seen = new Set();
  const options = [...DEPT_OPTIONS_BASE];

  Object.values(AA_DEPT_MAP).forEach((categoryMap) => {
    (categoryMap[lobType] || []).forEach((opt) => {
      if (opt.value && !seen.has(opt.value)) {
        seen.add(opt.value);
        options.push(opt);
      }
    });
  });

  return options;
};

export const SPOC_FIELDS = [
  {
    name: "employeeName",
    label: "Employee Name",
    type: "text",
    placeholder: "Enter full name",
    required: true,
  },
  {
    name: "email",
    label: "Email ID",
    type: "email",
    placeholder: "Enter email address",
    required: true,
  },
  {
    name: "password",
    label: "Password",
    type: "password",
    placeholder: "Enter password",
    required: true,
    hideOnView: true,
    hideOnEdit: true,
  },
  {
    name: "lob",
    label: "Entity LOB Type",
    type: "select",
    placeholder: "Select entity LOB type",
    required: true,
    dynamicLob: true,
    editableOnEdit: true,
    options: LOB_OPTIONS_ALL,
  },
  {
    name: "department",
    label: "AA - Department Function",
    type: "select",
    placeholder: "Select department function",
    required: true,
    dynamicDept: true,
    editableOnEdit: true,
    options: DEPT_OPTIONS_BASE,
  },
  {
    name: "role",
    label: "Role",
    type: "select",
    placeholder: "Select Role",
    required: true,
    options: [
      { value: "", label: "Select Role" },
      { value: "Admin", label: "Admin" },
      { value: "SPOC", label: "SPOC" },
    ],
  },
];

export const SPOC_EMPTY_FORM = {
  employeeName: "",
  email: "",
  password: "",
  mobileNumber: "",
  lob: "",
  department: "",
  role: "Admin",
};

export const SPOC_COLUMNS = [
  { key: "employeeId", label: "Employee ID" },
  { key: "employeeName", label: "Employee Name" },
  { key: "email", label: "Email ID" },
  { key: "lob", label: "LOB Type" },
  { key: "department", label: "AA Department" },
  { key: "role", label: "Role" },
];
